import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { UiKitContext } from '../../internal/context';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Провайдер для переопределения свойств React-контекста Ui-Kit. В корне приложения рекомендуется использовать UiKitRoot.
 */
export function UiKitContextProvider(_ref) {
  let {
      children
    } = _ref,
    propsContext = _objectWithoutProperties(_ref, _excluded);
  const currentContext = React.useContext(UiKitContext);
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const nextContext = _objectSpread(_objectSpread({}, currentContext), propsContext);
  return /*#__PURE__*/_jsx(UiKitContext.Provider, {
    value: nextContext,
    children: children
  });
}